import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBeer, faMartiniGlass, faWhiskeyGlass, faWineGlass, faBurger, faGamepad, faDice, faMusic, faFootball, faWheelchair, faMicrophone, faChampagneGlasses, faBowlFood } from "@fortawesome/free-solid-svg-icons";
import './Amenities.css';
import PoolBall from './poolball8.svg';
//font awesome icons?
function Amenities() {
    return(
        <div>
            <h2 className="amHeadings">Offerings</h2>
            <ul className="amList">
                <li><FontAwesomeIcon icon={faBeer} />&ensp;Beer</li>
                <li><FontAwesomeIcon icon={faMartiniGlass} />&ensp;Cocktails</li>
                <li><FontAwesomeIcon icon={faWhiskeyGlass} />&ensp;Liquor</li>
                <li><FontAwesomeIcon icon={faWineGlass} />&ensp;Wine</li>
                <li><FontAwesomeIcon icon={faBurger} />&ensp;Food</li>
            </ul>
            <h2 className="amHeadings">Amenities</h2>
            <ul className="amList">
                <li><img src={PoolBall} alt="" height={'13em'}/>&ensp;Pool Table</li>
                <li><FontAwesomeIcon icon={faGamepad} />&ensp;Bar Games</li>
                <li><FontAwesomeIcon icon={faDice} />&ensp;Lottery</li>
                <li><FontAwesomeIcon icon={faMusic} />&ensp;JukeBox</li>
                <li><FontAwesomeIcon icon={faFootball} />&ensp;Sports</li>
                <li><FontAwesomeIcon icon={faBowlFood} />&ensp;Takeout</li>
                <li><FontAwesomeIcon icon={faWheelchair} />&ensp;Wheelchair Accessible</li>
                <li><FontAwesomeIcon icon={faMicrophone} />&ensp;Karaoke Nights</li>
                <li><FontAwesomeIcon icon={faChampagneGlasses} />&ensp;Event Hosting</li>
            </ul>
        </div>
    )
}

export default Amenities;